import styles from './ClearableInput.module.scss'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faTimesCircle} from '@fortawesome/free-solid-svg-icons'

export default function ClearableInput({children, showClear, onClear}) {
  return (
    <div className={styles.inputWrapper}>
      {children}

      {showClear &&
        <FontAwesomeIcon icon={faTimesCircle} size="sm" className={`text-secondary ${styles.clearIcon}`} onClick={onClear} />
      }
    </div>
  )
}
